module.exports = __webpack_public_path__ + "b670305a484f3405e5783c87c1884839.ttf";